import localStorage from 'utils/localStorage'

const RECENT_EMOJI_LOCALSTORAGE_KEY = 'recent_emoji'
const defaultRecentEmoji: Record<string, number> = { blush: 1 }

const getRecentEmojiObj = () => {
  try {
    const recentEmoji: Record<string, number> | null = JSON.parse(
      localStorage.getItem(RECENT_EMOJI_LOCALSTORAGE_KEY) || 'null',
    )

    return recentEmoji || defaultRecentEmoji
  } catch (error) {
    console.error(error)
    return defaultRecentEmoji
  }
}

/**
 * @deprecated it's used just for backward compatibility with the old emoji storage
 */
export const getRecentEmoji = () => {
  const recentEmoji = getRecentEmojiObj()
  return Object.keys(recentEmoji).sort((a, b) => (recentEmoji[a] < recentEmoji[b] ? 1 : -1))
}
